import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CommissionAccrual, CommissionAccrualCreate, CommissionAccrualFilter } from '../data/commissionAccrual';

export function createCommissionAccrualService(client: AxiosInstance) {
  return createCrudService<CommissionAccrual, CommissionAccrualCreate, CommissionAccrualFilter>(
    client,
    '/accounting/CommissionAccrual',
    'id',
  );
}

export type CommissionAccrualService = CrudService<CommissionAccrual, CommissionAccrualCreate, CommissionAccrualFilter>;
